<template>
  <div>
    <v-img
      v-for="(file, index) in imageArr"
      :key="index"
      :src="file"
      :max-width="maxWidth"
      :max-height="maxHeight"
      contain
      :alt="altText2"
      :class="classes"
      :position="position"
      @load="loaded = true"
      :lazy-src="lazySrc"
    />
    <v-fade-transition>
      <div class="subtleText" v-if="!loaded">
        {{ placeholder }}
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";
// import HardLinksMixin from "@/assets/js/cls/HardLinksMixin";

export default {
  name: "ProductImage",
  mixins: [
    ClCompanyMixin,
    // HardLinksMixin
  ],
  props: {
    allImages: {
      // for soft lenses where images are in a comma-separated list
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "absolute",
      // NOTE: use "absolute" for generic file (fileString must be absolute path)
      // "scl" for soft lens image file ( path will be prepended)
      // "softCompany" for company logo file (path will be prepended)
      // "companyId" - also requires "companyId" param to be set, grabs the image file name/path from the store
    },
    maxWidth: {
      type: Number,
      default: 300,
    },
    maxHeight: {
      type: Number,
      default: 150,
    },
    fileString: {
      type: String,
      default: "",
      // usually just one file, but (for soft lenses), may be a comma-separated list
    },
    companyId: {
      type: Number,
      default: null,
    },
    altText: {
      type: String,
      default: "",
    },
    classes: {
      type: String,
      default: "mx-auto",
    },
    position: {
      type: String,
      default: "center center",
    },
    placeholder: null,
    lazySrc: null,
  },
  data: function () {
    return {
      baseUrls: {
        scl: "https://www.eyedock.com/modules/Lenses/pnimages/lens_images/",
        softCompany:
          "https://www.eyedock.com/modules/Lenses/pnimages/comp_logos/",
        other: "",
      },
      loaded: false,
    };
  },
  methods: {},
  computed: {
    imageArr: function () {
      let fileString = this.fileString;
      if (this.type == "companyId") fileString = this.companyImageById;
      if (!fileString) return "";

      let baseUrl = "";
      if (this.baseUrls[this.type]) baseUrl = this.baseUrls[this.type];

      // it's dumb, but scl images can be a comma-separated list of file names
      let arr = fileString.split(",");
      let fileArr = arr.map((item) => {
        return baseUrl + item.trim();
      });
      if (!this.allImages) fileArr = [fileArr[0]];
      return fileArr;
    },
    companyImageById: function () {
      if (!this.companyId) return "";
      return this.logoForCompanyId(this.companyId);
    },
    altText2: function () {
      if (this.altText) return this.altText;
      if (this.type == "companyId")
        return this.nameForCompanyId(this.companyId);
      return null;
    },
    // placeholder2: function () {
    //   return this.placeholder ? this.placeholder : this.altText2;
    // },
  },
};
</script>

<style scoped></style>
